import { render, staticRenderFns } from "./CustomerReviewTable.vue?vue&type=template&id=455fb8f4&scoped=true"
import script from "./CustomerReviewTable.vue?vue&type=script&lang=ts"
export * from "./CustomerReviewTable.vue?vue&type=script&lang=ts"
import style0 from "./CustomerReviewTable.vue?vue&type=style&index=0&id=455fb8f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455fb8f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455fb8f4')) {
      api.createRecord('455fb8f4', component.options)
    } else {
      api.reload('455fb8f4', component.options)
    }
    module.hot.accept("./CustomerReviewTable.vue?vue&type=template&id=455fb8f4&scoped=true", function () {
      api.rerender('455fb8f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/CustomerReviewTable.vue"
export default component.exports